import axios from "axios";
import { getBaseUrl } from "./config";

const apiClient = axios.create({
  baseURL: getBaseUrl(), // Replace with your base API URL
  timeout: 30000, // Optional: Set a timeout for requests
});

// Function to handle API requests
const request = async (url, options) => {
  const {
    method = "GET",
    body,
    params = null,
    headers = null,
    auth = false,
  } = options;
  
  try {
    const apiHeaders = {
      "Content-Type": "application/json",
      ...headers, // Allow overriding default headers
    };

    if (auth) {
      const token = localStorage.getItem("token");
      apiHeaders.Authorization = `Bearer ${token}`;
    }

    const response = await apiClient({
      url,
      method,
      data: body, // For POST, PUT, etc.
      params, // For query parameters in GET requests
      headers: apiHeaders,
    });

    return response.data;
  } catch (error) {
    if (error.response) {
      // Handle server-side errors
      console.error("API Error:", error.response.data);
      throw error.response.data;
    } else if (error.request) {
      // Handle network errors
      console.error("Network Error:", error.request);
      throw { message: "Network Error", error };
    } else {
      // Handle unexpected errors
      console.error("Unexpected Error:", error.message);
      throw { message: error.message };
    }
  }
};

export default request;